<button mat-icon-button class="close-btn" (click)="close()">
  <mat-icon>close</mat-icon>
</button>
<div class="container">
  <span class="snack-text">{{ text }}</span>
  <button mat-button (click)="close()">
    {{ textButton | uppercase }}
  </button>
</div>
